export default __webpack_public_path__ + "static/lynes-e05e101093969e2960d6a0ea8aa9225d.png";